import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { devLogin, verify } from "@/lib/atlasApi";
import { ShieldCheck } from "lucide-react";
import logo from "@/assets/logo.png";

const ROLES = ["admin", "chef", "researcher"];

export default function DevLogin({ onLogin }) {
  const [sub, setSub] = useState("chef-ana");
  const [role, setRole] = useState("admin");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      await devLogin(sub || "dev-user", [role]);
      const v = await verify();
      onLogin(v);
    } catch (e) {
      setError("Falha no dev-login. Verifique se o backend está em modo dev.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div
        className="w-full max-w-md rounded-2xl border border-[#1F2937] bg-[#111827]/80 backdrop-blur p-8 shadow-2xl"
        data-testid="dev-login-card"
      >
        <div className="flex items-center gap-3 mb-1">
          <img src={logo} alt="FAWKES ATLAS" className="h-20 w-20 object-contain" data-testid="dev-login-logo" />
          <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Inter, sans-serif" }}>
            FAWKES ATLAS
          </h1>
        </div>
        <p className="text-sm text-slate-400 mb-6" style={{ fontFamily: "JetBrains Mono, monospace" }}>
          Sua Enciclopédia Gastronômica · dev access
        </p>

        <label className="text-xs uppercase tracking-wider text-slate-400">Identidade (sub)</label>
        <Input
          data-testid="dev-login-sub"
          value={sub}
          onChange={(e) => setSub(e.target.value)}
          className="mt-1 mb-4 bg-[#0B0F19] border-[#1F2937]"
        />

        <label className="text-xs uppercase tracking-wider text-slate-400">Papel (role)</label>
        <div className="mt-2 mb-6 grid grid-cols-3 gap-2">
          {ROLES.map((r) => (
            <button
              key={r}
              data-testid={`dev-login-role-${r}`}
              onClick={() => setRole(r)}
              className={`rounded-lg py-2 text-sm capitalize transition-colors border ${
                role === r
                  ? "bg-[#FF6B2B] text-white border-[#FF6B2B] font-semibold"
                  : "bg-transparent text-slate-300 border-[#2A3447] hover:border-[#FF6B2B]/60"
              }`}
            >
              {r}
            </button>
          ))}
        </div>

        {error && <p className="text-sm text-[#FF007A] mb-3" data-testid="dev-login-error">{error}</p>}

        <Button
          data-testid="dev-login-submit"
          onClick={submit}
          disabled={busy}
          className="w-full bg-[#FF6B2B] text-white hover:bg-[#E05A2B] font-semibold"
        >
          <ShieldCheck className="h-4 w-4 mr-2" />
          {busy ? "Entrando…" : "Entrar no Workbench"}
        </Button>
        <p className="mt-4 text-[11px] text-slate-500 text-center">
          Produção usa o SSO oficial do SOP &amp; RAFT · esta tela existe apenas em modo dev.
        </p>
      </div>
    </div>
  );
}
